export { AttachmentFile as default } from 'choerodon-ui/dataset';
export { FileLike } from 'choerodon-ui/dataset/data-set/AttachmentFile';
